import {generatePath} from 'react-router-dom'

import type {GetPathFunc} from './../types'

// Нужно при путешествии по тарифам сохранять выбранный способ оплаты, но отбрасывать остальные параметры
const SEARCH_PARAMS_WHITELIST = ['payment_kind']

export const createGetPath = (rootPath: string = ''): GetPathFunc => {
  return (params = {}) => {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.forEach((_, key) => {
      if (!SEARCH_PARAMS_WHITELIST.includes(key)) {
        searchParams.delete(key)
      }
    })
    const search = searchParams.toString()
    return `${generatePath(`${rootPath}/:country?/:city?/:tariff?`, params)}${search ? '?' + search : ''}`
  }
}
